import { useRefcodeLookup } from "../hooks/useRefcodeLookup";
import { WalletLink } from "./WalletLink";

interface RefcodeWalletLinkProps {
  refcode: string;
}

export function RefcodeWalletLink({ refcode }: RefcodeWalletLinkProps) {
  const { data, isLoading, error } = useRefcodeLookup(refcode);

  if (isLoading) {
    return <span className="font-mono text-gray-400">Loading…</span>;
  }

  if (error || !data?.data) {
    return (
      <span className="font-mono text-gray-300" title="Unknown wallet">
        {refcode}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-2">
      <WalletLink address={data.data.walletAddress} />
      <span className="text-gray-500 text-xs font-mono">{refcode}</span>
    </span>
  );
}
